import React, { Component } from 'react';
import { bindActionCreators } from 'redux'
import classNames from 'classnames';
import { ToggleButton } from 'primereact/togglebutton';
import { AppTopbar } from '../AppTopbar';
import { AppInlineProfile } from '../AppInlineProfile';
import { AppFooter } from '../AppFooter';
import { AppMenu } from '../AppMenu';
import { Route } from 'react-router-dom';
import { Dashboard } from '../demo/Dashboard';
import { FormsDemo } from '../demo/FormsDemo';
import { SampleDemo } from '../demo/SampleDemo';
import { DataDemo } from '../demo/DataDemo';
import { PanelsDemo } from '../demo/PanelsDemo';
import { OverlaysDemo } from '../demo/OverlaysDemo';
import { MenusDemo } from '../demo/MenusDemo';
import { MessagesDemo } from '../demo/MessagesDemo';
import { ChartsDemo } from '../demo/ChartsDemo';
import { MiscDemo } from '../demo/MiscDemo';
import { EmptyPage } from '../demo/EmptyPage';
import { Documentation } from '../demo/Documentation';
import { UtilsDemo } from '../demo/UtilsDemo';
import 'primereact/resources/primereact.min.css';
// import 'fullcalendar/dist/fullcalendar.css';
import 'font-awesome/css/font-awesome.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

import style from './styleWastetranRegis.css';
import { connect } from 'react-redux'
import { ScrollPanel } from 'primereact/scrollpanel';
import ScrollAnimation from 'react-animate-on-scroll';
import { Card } from 'primereact/card';
import { Chips } from 'primereact/chips';
import * as LocationService from '../../service/LocationService'
import { API_ROOT ,WEB_ROOT} from '../../constants/api'

import * as ServerAPI from './service';
import { Panel } from 'primereact/panel';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import { RadioButton } from 'primereact/radiobutton';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { FileUpload } from 'primereact/fileupload';
import { Growl } from 'primereact/growl';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { axios } from 'axios';
import { ProgressSpinner } from 'primereact/progressspinner';
import {CEInputText,CECalendar,CEDropdown, CEPassword} from '../../features/input';
import AddU3View from '../profile/AddU3View'


class WastetranRegisContainer extends Component {
    static propTypes = {

    }

    static defaultProps = {
    }
    bindAuthenFacebook() {
        var authFacebook = JSON.parse(localStorage.getItem('auth-facebook'));
        if (authFacebook) {
            if (authFacebook.id) {
                var name = authFacebook.name.split(" ");
                var fname = name[0];
                var lname = name[1];
                this.setState({ isAuthenFacebook: true });
                this.setState({ facebookId: authFacebook.id })
                this.setState({ email: authFacebook.email });
                this.setState({ firstName: fname });
                this.setState({ lastName: lname });
            }
        }
    }
    bindAuthenGoogle() {
        var authGoogle = JSON.parse(localStorage.getItem('auth-google'));
        if (authGoogle) {
            if (authGoogle.profileObj && authGoogle.tokenId) {

                this.setState({ isAuthenGoogle: true });
                this.setState({ googleId: authGoogle.googleId })
                this.setState({ email: authGoogle.profileObj.email });
                this.setState({ firstName: authGoogle.profileObj.givenName });
                this.setState({ lastName: authGoogle.profileObj.familyName });
            }
        }
    }
    componentDidMount() {
        const { locationServiceProps } = this.props
        locationServiceProps.getProvice()
        this.bindAuthenFacebook();
        this.bindAuthenGoogle();
    }
    constructor() {
        super();
        this.state = {
            // showPass: false,
            errorMessageLastStep: '',
            errorMessageUsername: '',
            messageUsername: '',
            errorMessagePassword: '',
            errorMessageConfirmPassword: '',
            errorMessageTelephoneNumber1: '',
            errorMessageOrgNo: '',
            confirmPassword: '',
            prefixCode: 0,
            firstName: '',
            lastName: '',
            personType: '1',
            companyTypeCode: 0,
            companyName: '',
            companyNo: '',
            legalType: null,
            nameTitle: null,
            vehicle: null,
            telephoneNumber1: '',
            vehicleType: 0,
            districtCode: 0,
            provinceCode: 0,

            //province: null,
            //district: null,
            checkedPasswordVisible: false,
            typePasswordInput: 'password',
            acceptFileExt: '.jpg,.jpeg,.png,.pdf,.JPG,.JPEG,.PNG,.PDF',
            acceptImgExt: '.jpg,.jpeg,.png,.JPG,.JPEG,.PNG',
            showPass: [],
            values2: [],
            legalSelectItems: [
                {name : 'บริษัทจำกัด', code: '1' },
                {name : 'ห้างหุ้นส่วน', code: '2' },
                {name : 'บริษัทมหาชน', code: '3' },
                {name : 'ห้างร้าน', code: '4' },
            ],
            personPrefixs: [
                {name : 'นาย', code: '1' },
                {name : 'นาง', code: '2' },
                {name : 'นางสาว', code: '3' },
            ],
            // provinceSelectItems: [
            //     {label: 'กรุงเทพมหานคร', value: 'Bangkok'},
            //     {label: 'นครปฐม', value: 'Nakhon Pathom'},
            //     {label: 'สมุทรปราการ', value: 'Samut Prakan'},
            // ],
            // districtSelectItems: [
            //     {label: 'สวนหลวง', value: 'Suan Luang'},
            //     {label: 'บางกะปิ', value: 'Bangkapi'},
            //     {label: 'ดินแดง', value: 'Din Daeng'},
            // ],
            currentPage: 1,
            provinceSelected: {},
            districtSelected: null,
            districtsSelected: [],
            showProgress: false,
            hideCancel: false,
            isAuthenFacebook: false,
            facebookId: '',
            isAuthenGoogle: false,
            googleId: '',
            fileImgVehicle:null,
            isvalid_telephoneNumber1: false,
            isvalid_email: true,
            isvalid_companyNo: false,

            listSuggestions: null,
            suggestions:"",
            valueU3:[]
        };
        this.bindAuthenFacebook = this.bindAuthenFacebook.bind(this);
        this.bindAuthenGoogle = this.bindAuthenGoogle.bind(this);
        this.onLagalSelect = this.onLagalSelect.bind(this);
        this.onTitleSelect = this.onTitleSelect.bind(this);
        this.onBasicUploadAuto = this.onBasicUploadAuto.bind(this);
        //this.onProvinceSelect = this.onProvinceSelect.bind(this);
        this.onDistrictChanged = this.onDistrictChanged.bind(this);
        this.onCheckChange = this.onCheckChange.bind(this);
        this.onUserChange = this.onUserChange.bind(this);
        this.onProvinceChanged = this.onProvinceChanged.bind(this);
        this.onClickedAddArea = this.onClickedAddArea.bind(this);
        this.customChipRemove = this.customChipRemove.bind(this);
        this.onFileIDCardChanged = this.onFileIDCardChanged.bind(this);
        this.onFileVehicleChanged = this.onFileVehicleChanged.bind(this);
        this.onFileRegisChanged = this.onFileRegisChanged.bind(this);
        this.onFilePersonChanged = this.onFilePersonChanged.bind(this);
        this.setPasswordVisible = this.setPasswordVisible.bind(this);
        this.isNotvalidStep1 = this.isNotvalidStep1.bind(this);
        this.isNotvalidStep2 = this.isNotvalidStep2.bind(this);
        this.isNotvalidStep3 = this.isNotvalidStep3.bind(this);
        this.onCompanyNoChanged = this.onCompanyNoChanged.bind(this);

        this.onUsernameU3Changed = this.onUsernameU3Changed.bind(this);
        this.onSelectAutoCompleteSearchName = this.onSelectAutoCompleteSearchName.bind(this);
        this.onAddU3 = this.onAddU3.bind(this);
        this.suggestBrands = this.suggestBrands.bind(this);
        this.onChangeChips = this.onChangeChips.bind(this);
        this.itemTemplateChipU3 = this.itemTemplateChipU3.bind(this);
        this.onRemoveU3 = this.onRemoveU3.bind(this);
        this.customChipRemoveRemoveU3 = this.customChipRemoveRemoveU3.bind(this);

    }

    customChip(item) {
        return (
            <div>
                <span>{item.districtName} {item.provinceName} </span>
                <i className="pi pi-user-plus" style={{ fontSize: '14px' }}></i>
            </div>
        );
    }
    setPasswordVisible(e) {

        this.setState({ checkedPasswordVisible: e.value })
        if (e.value) {
            this.setState({ typePasswordInput: 'text' });
        } else {
            this.setState({ typePasswordInput: 'password' });
        }
    }
    customChipRemove(e) {
        console.log(e.value);

        var array = this.state.districtsSelected; // make a separate copy of the array
        var index = array.indexOf(e.value[0])
        if (index !== -1) {
            array.splice(index, 1);
            this.setState({ districtsSelected: array }, this.isNotvalidStep3);
        }
        console.log(array);
    }
    //dropdown
    onLagalSelect(e) {
       console.log(e)
        this.setState({ legalType: e.value });
        this.setState({ companyTypeCode: e.value.code }, this.isNotvalidStep1);
    }

    //dropdown
    onTitleSelect(e) {
        this.setState({ personPrefix: e.value });
        console.log(e);
        this.setState({ prefixCode: e.value.code }, this.isNotvalidStep1);
    }

    //upload picture
    onBasicUploadAuto(event) {
        this.growl.show({ severity: 'info', summary: 'Success', detail: 'File Uploaded with Auto Mode' });
    }

    //province dropdown
    // onProvinceSelect(e){
    //     this.setState({province: e.value});
    // }

    //district dropdown
    onDistrictChanged(e) {
        this.setState({ districtSelected: e.value }, this.isNotvalidStep3);
        
        var districtSelect = e.value;
        var isNotvalid = false;
        console.log(districtSelect.districtCode)
        console.log(this.state.districtsSelected)
        if(this.state.districtsSelected.length != 0){
            this.state.districtsSelected.forEach(districts => {
                console.log(districts.districtCode)
                console.log(districtSelect.districtCode)
                if(districts.districtCode == districtSelect.districtCode){
                    isNotvalid = true;
                }
            });
            if(isNotvalid){
                this.showWarn("ในรายการมีพื่นที่นี้อยู่แล้ว");
            }else{
                this.state.districtsSelected.push(districtSelect);
            }
        }else{
            this.state.districtsSelected.push(districtSelect);
        }

        //this.state.districtsSelected.push(e.value);
        this.setState({ districtCode: e.value.districtCode });
    }

    onProvinceChanged(e) {
        console.log(e);
        const { locationServiceProps } = this.props
        this.setState({ provinceSelected: e.value }, this.isNotvalidStep3);
        locationServiceProps.getDistrict(e.value.provinceCode);
        this.setState({ provinceCode: e.value.provinceCode });
    }
    onCheckChange(e) {
        let showPassCheck = [...this.state.showPass];

        if (e.checked)
            showPassCheck.push(e.value);
        else
            showPassCheck.splice(showPassCheck.indexOf(e.value), 1);

        this.setState({ showPass: showPassCheck });
    }
    onClickedAddArea() {
        //this.onDistrictChanged();

        // console.log(this.state.districtSelected)
        // if(this.state.districtsSelected){
        //     this.state.districtsSelected.forEach(districts => {
        //         console.log(districts)
        //         console.log(this.state.districtSelected)
        //         if(districts == this.state.districtSelected){
        //             this.showWarn("ในรายการมีพื่นที่นี้อยู่แล้ว");
        //         }else{
        //             this.state.districtsSelected.push(this.state.districtSelected);
        //         }
        //     });
        // }else{
        //     this.state.districtsSelected.push(this.state.districtSelected);
        // }

        //this.state.districtsSelected.push(this.state.districtSelected);
    }
    onCancelClick() {
        localStorage.removeItem('auth-facebook');
        localStorage.removeItem('auth-google');
        window.open(WEB_ROOT,"_self");
        //window.location = "/#/";
    }
    onCancelNotAccept() {
        //window.open(WEB_ROOT,"_self");
        window.location = "/#/";
    }
    onFileIDCardChanged(e) {
       

        var fileNotValidFunc = function(ref){
            ref.showWarn("ประเภทไฟล์ที่รองรับ .png .jpg หรือ .jpeg เท่านั้น");
            var callback = function(){
                ref.setState({ fileImgIden: null });
            }
            ref.setState({ fileImgIden: e.files[0] },callback);
        }
        if(e.files[0]){
            var filename = e.files[0].name;
            var index = filename.lastIndexOf('.');
            if(index != -1){
                var ext = filename.substring(index+1, filename.length).toLowerCase();
                var isvalid = ext == 'png' || ext == 'jpg' || ext == 'jpeg';
                if(isvalid){
                    this.setState({ fileImgIden: e.files[0] });
                }else{
                    fileNotValidFunc(this);
                }
            }else fileNotValidFunc(this);
        }else fileNotValidFunc(this);
    }
    onFileRegisChanged(e) {
     
        var fileNotValidFunc = function(ref){
            ref.showWarn("ประเภทไฟล์ที่รองรับ .png .jpg หรือ .jpeg เท่านั้น");
            var callback = function(){
                ref.setState({ fileImgRegis: null });
            }
            ref.setState({ fileImgRegis: e.files[0] },callback);
        }
        if(e.files[0]){
            var filename = e.files[0].name;
            var index = filename.lastIndexOf('.');
            if(index != -1){
                var ext = filename.substring(index+1, filename.length).toLowerCase();
                var isvalid = ext == 'png' || ext == 'jpg' || ext == 'jpeg';
                if(isvalid){
                    this.setState({ fileImgRegis: e.files[0] });
                }else{
                    fileNotValidFunc(this);
                }
            }else fileNotValidFunc(this);
        }else fileNotValidFunc(this);
    }
    onFilePersonChanged(e) {
        

        
        var fileNotValidFunc = function(ref){
            ref.showWarn("ประเภทไฟล์ที่รองรับ .png .jpg หรือ .jpeg เท่านั้น");
            var callback = function(){
                ref.setState({ fileImgPerson: null });
            }
            ref.setState({ fileImgPerson: e.files[0] },callback);
        }
        if(e.files[0]){
            var filename = e.files[0].name;
            var index = filename.lastIndexOf('.');
            if(index != -1){
                var ext = filename.substring(index+1, filename.length).toLowerCase();
                var isvalid = ext == 'png' || ext == 'jpg' || ext == 'jpeg';
                if(isvalid){
                    this.setState({ fileImgPerson: e.files[0] });
                }else{
                    fileNotValidFunc(this);
                }
            }else fileNotValidFunc(this);
        }else fileNotValidFunc(this);
    }
    onFileVehicleChanged(e) {
       
        var fileNotValidFunc = function(ref){
            ref.showWarn("ประเภทไฟล์ที่รองรับ .png .jpg หรือ .jpeg เท่านั้น");
            var callback = function(){
                ref.setState({ fileImgVehicle: null });
            }
            ref.setState({ fileImgVehicle: e.files[0] },callback);
        }
        if(e.files[0]){
            var filename = e.files[0].name;
            var index = filename.lastIndexOf('.');
            if(index != -1){
                var ext = filename.substring(index+1, filename.length).toLowerCase();
                console.log(ext)
                var isvalid = ext == 'png' || ext == 'jpg' || ext == 'jpeg';
                if(isvalid){
                    this.setState({ fileImgVehicle: e.files[0] });
                }else{
                    fileNotValidFunc(this);
                }
            }else fileNotValidFunc(this);
        }else fileNotValidFunc(this);
    }

    onUsernameChanged(username) {
        this.setState({ errorMessageUsername: "" });
        this.setState({ messageUsername: "" });
        this.setState({ username: username });
        if (username.length >= 6) {
            const re = new RegExp("^[A-Za-z][A-Za-z0-9]*$");
            const isOk = re.test(username);
            if (isOk) {
                console.log(username);
                ServerAPI.checkExit(username).then((res) => {
                    console.log(res);
                    if (res.length > 0) {
                        this.setState({ errorMessageUsername: "ชื่อผู้ใช้ " + username + " มีอยู่แล้วในระบบ" });
                        this.setState({ messageUsername: "" });
                    } else {
                        this.setState({ messageUsername: "ชื่อผู้ใช้ " + username + " สามารถใช้งานได้" });
                        this.setState({ errorMessageUsername: "" });
                    }
                }).catch((error) => {
                    this.setState({ errorMessageUsername: "กรุณาติดต่อผู้ดูแลระบบ" });
                    this.setState({ messageUsername: "" });
                })
            } else {
                this.setState({ errorMessageUsername: "ตัวอักษรภาษาอังกฤษและตัวเลข โดยตัวแรกต้องเป็นภาษาอังกฤษเท่านั้น" });
                this.setState({ messageUsername: "" });
            }
        } else {
            this.setState({ errorMessageUsername: "กรุณากรอกอย่างน้อย 6 ตัวอักษร (ภาษาอังกฤษหรือตัวเลข)" });
            this.setState({ messageUsername: "" });
        }
        this.isNotvalidStep1();

    }

    onPasswordChanged(password) {
        this.setState({ errorMessagePassword: "" });
        this.setState({ password: password });

        if (password.length >= 6) {
            const re = new RegExp("^(?=.*[a-z])(?=.*[A-Z]).{6,}$");
            const isOk = re.test(password);
            if (!isOk) {
                this.setState({ errorMessagePassword: "ภาษาอังกฤษตัวพิมพ์เล็ก ตัวพิมพ์ใหญ่" });
            } else {
                this.setState({ password: password });
                this.setState({ errorMessagePassword: "" });

                if (password == this.state.confirmPassword) {
                    this.setState({ errorMessageConfirmPassword: "" });
                } else {
                    this.setState({ errorMessageConfirmPassword: "รหัสผ่านยืนยันไม่ตรงกัน" });
                }
            }
        } else {
            this.setState({ errorMessagePassword: "กรุณากรอกอย่างน้อย 6 ตัวอักษร (ภาษาอังกฤษตัวพิมพ์เล็ก ตัวพิมพ์ใหญ่)" });
        }
        this.isNotvalidStep1();
    }

    onConfirmPasswordChanged(cfpassword) {
        this.setState({ errorMessageConfirmPassword: "" });
        this.setState({ confirmPassword: "" });

        if (this.state.password == cfpassword) {
            this.setState({ confirmPassword: cfpassword }, this.isNotvalidStep1);
            this.setState({ errorMessageConfirmPassword: "" });
        } else {
            this.setState({ errorMessageConfirmPassword: "รหัสผ่านยืนยันไม่ตรงกัน" });
            this.setState({ confirmPassword: cfpassword });
        }
        this.isNotvalidStep1();
    }



    onUserChange(currentPage) {
        const nomalPerson = (
            <div className='p-grid'>
                {/* บุคคลธรรมดา */}
                <div className="p-col-12 p-md-12 p-lg-3" style={{ textAlign: 'left' }}>
                    <label class="register-label required">คำนำหน้าชื่อ</label>
                </div>
                <div className="p-col-12 p-md-12 p-lg-9" style={{ textAlign: 'left' }}>
                    {/* <Dropdown
                        value={this.state.personPrefix}
                        options={this.state.personPrefixs}
                        onChange={this.onTitleSelect} placeholder="เลือกคำนำหน้า" /> */}

                    <CEDropdown
                        required={true} isvalid={(valid) => console.log("Dropdown:"+ valid)}
                        value={this.state.personPrefix} 
                        options={this.state.personPrefixs}
                        onChange={this.onTitleSelect} 
                        optionLabel="name" 
                        placeholder="เลือกคำนำหน้า" />
                </div>
                <div className="p-col-12 p-md-12 p-lg-3" style={{ textAlign: 'left' }}>
                    <label class="register-label required">ชื่อ</label>
                </div>
                <div className="p-col-12 p-md-12 p-lg-9" style={{ textAlign: 'left' }}>
                    {/* <InputText type="text" value={this.state.firstName} className="input-100" placeholder="ชื่อ" onChange={(e) => this.setState({ firstName: e.target.value }, this.isNotvalidStep1)} /> */}
                    <CEInputText
                        id="firstName"
                        type="text"
                        className="input-100"
                        value={this.state.firstName}
                        name="firstName"
                        placeholder="ชื่อ"
                        tooltip="กรอกชื่อผู้ใช้"
                        maxlength={45}
                        required={true}
                        onChange={(e) => this.setState({ firstName: e.target.value }, this.isNotvalidStep1)}
                        isvalid={(valid) => console.log(valid)}
                    />
                </div>
                <div className="p-col-12 p-md-12 p-lg-3" style={{ textAlign: 'left' }}>
                    <label class="register-label required">นามสกุล</label>
                </div>
                <div className="p-col-12 p-md-12 p-lg-9" style={{ textAlign: 'left' }}>
                    {/* <InputText type="text" value={this.state.lastName} className="input-100" placeholder="นามสกุล" onChange={(e) => this.setState({ lastName: e.target.value }, this.isNotvalidStep1)} /> */}
                    
                    <CEInputText
                        id="lastName"
                        type="text"
                        className="input-100"
                        value={this.state.lastName}
                        name="lastName"
                        placeholder="นามสกุล"
                        tooltip="กรอกนามสกุลผู้ใช้งาน"
                        maxlength={45}
                        required={true}
                        onChange={(e) => this.setState({ lastName: e.target.value }, this.isNotvalidStep1)}
                        isvalid={(valid) => console.log(valid)}
                    />
                </div>
            </div>
        );
        const Legal = (
            <div className='p-grid'>
                {/* นิติบุคคล */}
                <div className="p-col-12" style={{ textAlign: 'left' }}>
                    <label class="register-label required">ประเภทนิติบุคคล</label>
                </div>
                <div className="p-col-12" style={{ textAlign: 'left' }}>
                    {/* <Dropdown
                        value={this.state.legalType}
                        options={this.state.legalSelectItems}
                        onChange={this.onLagalSelect} placeholder="เลือกประเภทนิติบุคล" /> */}
                    <CEDropdown
                        style={{ width: "100%" }}
                        required={true} isvalid={(valid) => console.log("Dropdown:"+ valid)}
                        value={this.state.legalType} 
                        options={this.state.legalSelectItems}
                        onChange={this.onLagalSelect} 
                        optionLabel="name" 
                        placeholder="เลือกประเภทนิติบุคคล" />
                </div>
                <div className="p-col-12">
                    <label className="register-label required">ชื่อนิติบุคคล</label>
                </div>
                <div className="p-col-12">
                    {/* <InputText type="text" value={this.state.companyName} className="input-100" placeholder="ชื่อนิติบุคคล" onChange={(e) => this.setState({ companyName: e.target.value }, this.isNotvalidStep1)} /> */}
                    <CEInputText  
                            id="companyName"                         
                            type="text"
                            className="input-100"
                            value={this.state.companyName}
                            name="companyName"
                            placeholder="ชื่อนิติบุคคล"
                            tooltip="กรอกชื่อนิติบุคคล"
                            maxlength={45}
                            required={true}
                            onChange={(e)=> this.setState({ companyName: e.target.value }, this.isNotvalidStep1)}
                            isvalid={(valid) => console.log(valid)}
                             />
                </div>
                <div className="p-col-12">
                    <label className="register-label required">เลขนิติบุคคล</label>
                </div>
                <div className="p-col-12">
                    <span style={{ color: 'red' }}>{this.state.errorMessageOrgNo} </span>
                    {/* <InputText type="text" value={this.state.companyNo} className="input-100" maxlength="13" keyfilter="pint" placeholder="เลขนิติบุคคล" onChange={(e) => this.setState({ companyNo: e.target.value }, this.isNotvalidStep1)} /> */}
                    <CEInputText 
                            id="companyNo"                          
                            type="number"
                            className="input-100"
                            value={this.state.companyNo}
                            name="companyNo"
                            placeholder="เลขนิติบุคคล"
                            tooltip="กรอกเลขนิติบุคคล"
                            mask="9999999999999"
                            required={true}
                            onChange={(e,v)=> this.onCompanyNoChanged(e.target.value,v)}
                            //onChange={(e)=> this.setState({ companyNo: e.target.value }, this.isNotvalidStep1)}
                            isvalid={(valid) => this.setState({isvalid_companyNo: valid})}
                             />
                </div>
            </div>
        );

        //logic select user type
        if (currentPage == 2) { //page one only
            if (this.state.personType !== null) {
                if (this.state.personType == 1) {
                    return nomalPerson;
                } else if (this.state.personType == 2) {
                    return Legal;
                }
            }
        }


        //this.setState({userType: e.value});
    }

    onCompanyNoChanged(orgNo,valid){
        this.setState({ errorMessageOrgNo: "" });
        this.setState({ companyNo: orgNo});
        if(orgNo.length == 13 && valid){
            this.setState({ companyNo: orgNo}, this.isNotvalidStep1)
            this.setState({ errorMessageOrgNo: "" });
        }else{
            this.setState({ errorMessageOrgNo: "กรุณากรอกหมายเลขนิติบุคคล 13 หลัก "}, this.isNotvalidStep1);
        }
    }

    onTelephoneNumber1Changed(telephoneNumber,valid) {
        console.log(telephoneNumber)
        this.setState({ errorMessageTelephoneNumber1: "" });
        this.setState({ telephoneNumber1: telephoneNumber});
        if (telephoneNumber.length == 10 && valid) {
            //this.setState({ errorMessageTelephoneNumber1: "" });
            console.log(this.state.isvalid_telephoneNumber1);
            var telNameModel = {
                telephoneNumber: telephoneNumber
            }
            ServerAPI.checkExitPhoneAndName(telNameModel).then((res) => {
                console.log(res);
                if (res.length > 0) {
                    this.setState({ errorMessageTelephoneNumber1: "หมายเลข " + telephoneNumber + " มีอยู่แล้วในระบบ" }, this.isNotvalidStep2);

                } else {
                    this.setState({ telephoneNumber1: telephoneNumber }, this.isNotvalidStep2);
                    this.setState({ errorMessageTelephoneNumber1: "" });
                }
            }).catch((error) => {
                this.setState({ errorMessageTelephoneNumber1: "กรุณาติดต่อผู้ดูแลระบบ" }, this.isNotvalidStep2);
                this.setState({ messageTelephoneNumber1: "" });

            })
        } else {
            this.setState({ errorMessageTelephoneNumber1: "กรุณากรอกหมายเลขโทรศัพท์เคลื่อนที่ 10 ตัวเลข (ขึ้นต้นด้วยเลข 0)" }, this.isNotvalidStep2);

        }

    }

    registerRequest() {
        console.log(this.state);

        

        const formData = new FormData();

        let u3ListString = []
        this.state.valueU3.forEach(item =>{
            if(item.uid === null){
                u3ListString.push({u3_uid : item.u3_uid})
            }else{
                u3ListString.push({u3_uid : item.uid})
            }
        })
        console.log(u3ListString);
        formData.set('u3ListString', JSON.stringify(u3ListString))
        
        formData.append('FileImgIden', this.state.fileImgIden);
        formData.append('FileImgRegis', this.state.fileImgRegis);
        formData.append('FileImgPerson', this.state.fileImgPerson);
        formData.append('FileImgVehicle', this.state.fileImgVehicle);

        formData.set('personType', this.state.personType || 0);
        formData.set('prefixCode', this.state.prefixCode || 0);
        formData.set('fristName', this.state.firstName);
        formData.set('lastName', this.state.lastName);
        formData.set('organizationTypeId', this.state.companyTypeCode || 0);
        formData.set('organizationName', this.state.companyName);
        formData.set('organizationNo', this.state.companyNo);
        formData.set('telephoneNumber1', this.state.telephoneNumber1);
        formData.set('telephoneNumber2', this.state.telephoneNumber2 || '');
        formData.set('lineId', this.state.lineId || '');
        formData.set('provinceCode', this.state.provinceCode || 0);
        formData.set('districtCode', this.state.districtCode || 0);
        formData.set('subDistrictCode', this.state.subDistrictCode || 0);
        formData.set('username', this.state.username);
        formData.set('email', this.state.email || '');
        formData.set('password', this.state.password);
        formData.set('confirmPassword', this.state.confirmPassword);
        formData.set('vehicleType', this.state.vehicleType || 0);
        formData.set('vehicleNo', this.state.vehicleNo || '');

        formData.set('areaListString', JSON.stringify(this.state.districtsSelected));
        formData.set('isAuthenFacebook', this.state.isAuthenFacebook);
        formData.set('facebookId', this.state.facebookId);
        formData.set('isAuthenGoogle', this.state.isAuthenGoogle);
        formData.set('googleId', this.state.googleId);

        ServerAPI.RegisterWasteTran(formData).then((res) => {
            console.log("response");
            if (res) {
                var index = res.toString().indexOf("Error:");
                console.log("find error:" + (index));
                if (index == -1) {
                    this.state.currentPage++;
                    this.forceUpdate();
                } else {
                    this.setState({ showProgress: false });
                    this.setState({ hideCancel: false });
                    this.setState({ errorMessageLastStep: res.toString() });
                }

            } else {
                this.setState({ showProgress: false });
                this.setState({ hideCancel: false });
                this.setState({ errorMessageLastStep: res.toString() });
            }
        }).catch((error) => {
            this.setState({ showProgress: false });
            this.setState({ hideCancel: false });
            this.setState({ errorMessageLastStep: error.toString() });
        })


    }

    showSuccess = (message) => {
        this.growl.show({ severity: 'success', summary: 'สถานะ', detail: message ? message : 'ทำรายการสำเร็จ' });
    }
    showWarn = (message) => {
        this.growl.show({ severity: 'warn', summary: 'สถานะ', detail: message ? message : 'มีบางอย่างผิดพลาด กรุณาตรวจสอบ' });
    }

    onSelectAutoCompleteSearchName(item) {
        // this.setState({ suggestions: item.value.search_name });

        this.state.suggestions = item.value.search_name

        console.log(this.state.suggestions);
        this.onAddU3()
    }

    suggestBrands(event) {
        console.log(event);
    }

    onUsernameU3Changed(search_name) {
        if(typeof( search_name)!="object")
        if(search_name.trim()!=""){
            this.setState({ suggestions: search_name });
            if (search_name.length >= 1) {
                ServerAPI.searchMemberName(search_name).then((res) => {
                    this.setState({listSuggestions:res})
                }).catch((error) => {

                })
            }
        }else this.setState({ suggestions: search_name });
    }

    onAddU3(){
        const {suggestions,valueU3,listSuggestions} = this.state
        if(suggestions != ""){
            let indexSugges = listSuggestions.findIndex(item => {
                return item.search_name == suggestions
            })
            if(valueU3.length > 0){
                let findExist = valueU3.findIndex(item =>{
                    return item.search_name == suggestions
                })
                if(findExist == -1){
                    this.state.valueU3.push(listSuggestions[indexSugges])
                }else{
                    this.showWarn("ข้อมูลซ้ำ กรุณาป้อนใหม่อีกครั้ง")
                }
            }else{
                this.state.valueU3.push(listSuggestions[indexSugges])
            }
            this.setState({suggestions:''})
        }
    }

    onChangeChips(e){
        this.setState({ valueU3: e.value })
    }

    itemTemplateAutoComplete(item) {
        return (
            <div className="p-clearfix">
                {item.search_name}
            </div>
        );
    }
    itemTemplateChipU3 = (item) => {
        return (
            <div>
                <span>{item.full_name}</span>
                <i className="pi pi-user-plus" style={{ fontSize: '14px' }}></i>
            </div>
        );
    }

    onRemoveU3 = (e) => {
        this.setState({
            valueU3: this.state.valueU3.filter(item => item.full_name != e.value[0].full_name)
        })
    }

    customChipRemoveRemoveU3(e) {
        console.log(e.value);
        console.log(this.state.valueU3);
        //if(this.state.valueU3.length !== 0)
        var array = this.state.valueU3; // make a separate copy of the array
        var index = array.indexOf(e.value[0])
        if (index !== -1) {
            array.splice(index, 1);
            this.setState({ valueU3: array });
        }
        console.log(array);
    }

    showPage = (currentPage) => {
        const {
            province,
            district
        } = this.props;
        //first Step agreement page
        const pageAgreement = (
            <div style={{ marginBottom: '7%',paddingLeft: '5px'}}>
		<h3>นโยบายคุ้มครองสิทธิความเป็นส่วนตัวของ ซี-ซาเล้ง</h3>
							<text>      &emsp;บริษัท แก้วกรุงไทย จำกัด (“บริษัทฯ”) ซึ่งประกอบกิจการและกำกับดูแลตลาดออนไลน์ภายใต้ชื่อ “C3Leng” ในประเทศไทยแต่เพียงผู้เดียว คำนึงถึงมาตราการปกป้องข้อมูลทุกรูปแบบที่บริษัทฯ มีในครอบครองทั้งหมดตามกฎหมายต่างๆ ที่เกี่ยวข้อง
		บริษัท แก้วกรุงไทย จำกัด ในฐานะผู้ควบคุมข้อมูลตามกฎหมาย มีสำนักงานตั้งอยู่เลขที่ 589 อาคารวิชชุวรรณ ชั้นที่ 2 ถนนรัชดาภิเษก แขวงดินแดง เขตดินแดง กรุงเทพมหานคร 10400 
		นโยบายความเป็นส่วนตัว (“นโยบาย”) นี้ ชี้แจงรายละเอียดเกี่ยวกับการได้มา การใช้/ประมวลผล และการเก็บรักษา ข้อมูลของผู้ใช้บริการ C3Leng ของบริษัทฯ เท่านั้น<br></br></text>
        
		<text>      &emsp;บริษัทฯ ให้ความสำคัญเกี่ยวกับความโปร่งใสในการดำเนินธุรกิจและการให้บริการต่อสมาชิกหรือผู้ใช้บริการ C3Leng ในฐานะเจ้าของข้อมูล (“คุณ”) นโยบายความเป็นส่วนตัวนี้ใช้บังคับเกี่ยวกับข้อมูลที่บริษัทฯ 
        เก็บรวบรวมและรักษาไว้ โดยอธิบายครอบคลุมถึงประเภท วัตถุประสงค์ และวิธีปฏิบัติเกี่ยวกับการใช้ประมวลผลและการเก็บรักษาข้อมูลต่างๆ อันได้แก่ ไอพีแอดเดรส (IP Address) คุกกี้ (Cookies) และ/หรือข้อมูลส่วนบุคคลที่คุณมอบให้ผ่านเว็บไซต์และแอพพลิเคชั่นของบริษัทฯ 
        ขณะที่ลงทะเบียนและใช้บริการ C3Leng ซึ่งรวมถึง ข้อมูล Facebook และ/หรือ Google Account ของคุณ
		คุณมีหน้าที่ต้องอ่านและรับทราบนโยบายนี้ทั้งหมดก่อนที่จะให้ข้อมูลใดๆ กับบริษัทฯ  การใช้เว็บไซต์หรือแอพพลิเคชั่น C3Leng หรือลงทะเบียนการขอใช้บริการและกิจกรรมอื่นๆ ของเรา โดยคุณจะต้องให้ความยินยอมผ่านการแสดงเจตนาโดยชัดแจ้งหรือโดยนัยในการอนุญาตให้บริษัทฯ รวบรวม ใช้และเก็บรักษาข้อมูลของคุณตามที่กำหนดไว้ตามนโยบายนี้
		หากคุณมีข้อสงสัยเกี่ยวกับแนวทางปฏิบัติตามนโยบายความเป็นส่วนตัวนี้ รวมถึงข้อกังวลหรือข้อร้องเรียนเกี่ยวกับข้อมูลของคุณประการใด โปรดติดต่อโดยส่งเป็นจดหมายหรือคำร้องผ่านทางอีเมลมาที่ adminc3leng@c3leng.com
		ข้อมูลที่บริษัทฯรวบรวม</text>
		<h3>แหล่งข้อมูล</h3>
		<text>      &emsp;บริษัทฯรวบรวมข้อมูลเกี่ยวกับคุณหรือข้อมูลเกี่ยวกับอุปกรณ์การใช้งานของคุณจากคุณโดยตรงเท่านั้น ตราบเท่าที่คุณอนุญาตโดยชัดแจ้งหรือโดยนัยให้เราใช้ประมวลผลและเก็บรักษาข้อมูลดังกล่าวผ่านทาง</text>
		<text>
			&ensp;•	เว็บไซต์ C3Leng<br></br>
			&ensp;•	แอปพลิเคชั่น C3Leng<br></br>
			&ensp;•	Facebook (ข้อมูลบัญชีสมาชิกที่เป็นสาธารณะ)<br></br>
			&ensp;•	Google Account (ข้อมูลบัญชีสมาชิกที่เป็นสาธารณะ)<br></br>
			&ensp;•	อุปกรณ์ของผู้ใช้ (คอมพิวเตอร์ และ/หรือ โทรศัพท์มือถือ)<br></br>
		</text>
		<h3>ประเภทของข้อมูล</h3>
		<text>จากแหล่งข้อมูลข้างต้น ข้อมูลที่บริษัทฯจะเก็บรวบรวมมีดังนี้<br></br></text>
		<text>	

		&ensp;•	ชื่อ<br></br>
		&ensp;•	นามสกุล<br></br>
		&ensp;•	รูปภาพโปรไฟล์ / ภาพถ่าย<br></br>
		&ensp;•	ที่อยู่อีเมล์<br></br>
		&ensp;•	ชื่อบัญชี C3Len Application<br></br>
		&ensp;•	ชื่อและรหัสผ่านสำหรับบัญชีสมาชิก C3Leng<br></br>
		&ensp;•	ที่อยู่<br></br>
		&ensp;•	หมายเลขโทรศัพท์<br></br>
		&ensp;•	Facebook (member_id, public_profile)<br></br>
		&ensp;•	Google Account (member_id, public_profile)<br></br>
		&ensp;•	เนื้อหาหรือข้อมูลเกี่ยวกับการโพสต์สินค้าบนแพลตฟอร์มของ C3Leng<br></br>
		&ensp;•	คุกกี้<br></br>
		&ensp;•	ไอพีแอดเดรส (IP Address)<br></br>
		&ensp;•	ตำแหน่งทางภูมิศาสตร์<br></br>
		&ensp;•	เนื้อหาหรือข้อมูลในเครื่องมือแชทที่มีอยู่บน C3Leng<br></br>

		<h3>วิธีการเก็บรวบรวมข้อมูล</h3>
		เราเก็บรวบรวมข้อมูลเกี่ยวกับคุณ ดังต่อไปนี้<br></br>
		<text>
			&ensp;•	ในขณะที่คุณกรอกข้อมูลเพื่อการลงทะเบียนเปิดบัญชีสมาชิก C3Leng หรือดูแลปรับปรุงข้อมูลบัญชีสมาชิกของคุณ หรือขอรับบริการต่าง ๆ บนแพลตฟอร์ม C3Leng<br></br>
			&ensp;•	การลงทะเบียนบัญชีสมาชิก C3Leng บริษัทฯจะเก็บรวบรวมข้อมูลเฉพาะที่คุณได้ให้ในแบบฟอร์มที่แสดงอยู่บนแพลตฟอร์มเท่านั้น<br></br>
			&ensp;•	การเลือกลงทะเบียนบัญชีสมาชิก C3Leng โดยให้เชื่อมต่อกับบัญชีสมาชิก Facebook หรือ Google ของคุณ บริษัทฯจะเก็บรวบรวมข้อมูลโปรไฟล์จากบัญชีสมาชิก Facebook หรือ Google เฉพาะส่วนที่คุณเปิดเผยแก่สาธารณะ โปรดทราบว่าบริษัทฯไม่จัดเก็บหรือรับรู้รหัสผ่านเข้าบัญชีสมาชิก Facebook หรือ Google ของคุณในระบบข้อมูลของบริษัทฯแต่อย่างใด<br></br>
			&ensp;•	ข้อมูลเกี่ยวกับสินค้า คำบรรยายสินค้า รูปภาพ ที่ผู้ใช้งานได้ให้หรือปรากฏบนแพลตฟอร์มของ C3Leng<br></br>
			&ensp;•	ข้อมูลการสนทนาหรือข้อความระหว่างผู้ใช้งานที่ปรากฏในระบบสนทนา บนแพลตฟอร์ม C3Leng<br></br>
			</text>
		<br></br>
		บริษัทฯรวบรวมข้อมูลเกี่ยวกับอุปกรณ์ของคุณ ดังต่อไปนี้<br></br>
		&ensp;•	เมื่อคุณใช้เว็บไซต์หรือแอพพลิเคชั่น C3Leng บริษัทฯจะเก็บรวบรวมและวิเคราะห์ข้อมูลบางอย่างโดยอัตโนมัติซึ่งรวมถึงเบราว์เซอร์ที่ชี้เฉพาะเจาะจง ที่อยู่ IP และข้อมูลเกี่ยวกับระบบปฏิบัติการ อุปกรณ์ที่ชี้เฉพาะเจาะจง (เช่น Apple IDFA หรือ Android Advertising ID) ตำแหน่งทางภูมิศาสตร์และข้อมูลที่ชี้เฉพาะถึงอุปกรณ์อื่น ๆ ข้อมูลเกี่ยวกับอินเทอร์เน็ต รวมถึงรายละเอียดเกี่ยวกับธุรกรรมของคุณที่เกิดขึ้นบนเว็บไซต์และแอพ C3Leng<br></br>

		<h3>การใช้คุกกี้และเทคโนโลยีอื่น ๆ</h3>
		<text>&emsp;บริษัทฯ และบุคคลที่สามใช้เทคโนโลยีเพื่อเก็บรวบรวมข้อมูลเกี่ยวกับการใช้งานของคุณที่เกิดขึ้นบนเว็บไซต์และแอพ C3Leng</text>
			<text>
			&ensp;•	คุกกี้และเทคโนโลยีอื่น ๆ เพื่อการเก็บข้อมูล คุกกี้และเทคโนโลยีอื่น ๆ เพื่อการจัดเก็บ หมายความถึงไฟล์ที่มีข้อมูลเฉพาะของอุปกรณ์ที่ทางบริษัท ฯ หรือบุคคลที่สามได้ส่งถึงหรืออ่านได้จากอุปกรณ์ของคุณซึ่งจะบันทึกจดจำอุปกรณ์ดังกล่าวเพื่อวัตถุประสงค์ในการให้บริการ การบันทึก การวิเคราะห์พฤติกรรมและทางการตลาด  บริษัท ฯ และบุคคลที่สามจะใช้วิธีการอัตโนมัติในการอ่านหรือบันทึกข้อมูลอุปกรณ์ของคุณ ซึ่งรวมถึงคุกกี้ประเภทต่าง ๆ และเบราว์เซอร์ทั้งหลาย หรือปลั๊กอินอื่น ๆ (เช่นที่เก็บ HTML5 หรือฐานข้อมูลแบบ Flash) โดยคุณอาจเลือกที่จะตั้งค่าเว็บเบราว์เซอร์ของคุณให้ปฏิเสธการให้จัดเก็บคุกกี้บางประเภทหรือจัดให้มีการเตือนในกรณีที่มีการส่งคุกกี้บางประเภทได้ ซึ่งเบราว์เซอร์บางชนิดอาจสามารถถูกตั้งค่าที่คล้ายกันในแบบ HTML5 และ Flash ได้ อย่างไรก็ตามหากคุณป้องกันหรือปฏิเสธการให้จัดเก็บคุกกี้หรือที่เก็บข้อมูลในพื้นที่เว็บไซต์ของบริษัทฯ อาจส่งผลต่อการทำงานของเว็บไซต์ C3Leng ได้<br></br>
			&ensp;•	เทคโนโลยีอื่น ๆ ในการเก็บข้อมูล  บริษัทฯใช้เทคโนโลยีอัตโนมัติมาตรฐานต่าง ๆ ในการเก็บข้อมูลเช่นเว็บบีคอน (หรือเรียกว่า clear GIFs หรือพิกเซลแท็ก) หรือเทคโนโลยีที่คล้ายคลึงกันเพื่อการติดต่อหรือสื่อสารผ่านทางคุกกี้ต่าง ๆ และเพื่อติดตามผลการใช้งานของคุณบนเว็บไซต์และ/หรือแอพของบริษัทฯ นอกจากนี้บริษัทฯยังใช้เว็บบีคอนกับข้อความในอีเมล์เพื่อติดตามผลว่าคุณเปิดอ่านข้อความ รวมถึงการใช้งานอื่น ๆ ดังต่อไปนี้ <br></br>
			</text>
			<text>&emsp;ในบางกรณีบริษัทฯอาจใช้ข้อมูลดังกล่าวเพื่อการโฆษณาที่ดำเนินการโดยบุคคลที่สาม ซึ่งจะใช้วิธีการเก็บรวบรวมข้อมูลโดยอัตโนมัติ เช่นคุกกี้ ที่จะติดตามการใช้งานบนเว็บไซต์ของคุณเป็นช่วงๆไป โดยข้อมูลดังกล่าว รวมถึงข้อมูลเกี่ยวกับการเข้าชมเว็บไซต์หรือแอพพลิเคชั่นต่างๆ และข้อมูลอื่นๆ ที่บริษัทฯได้รับ อาจถูกใช้เพื่อปรับการเสนอโฆษณาที่เหมาะสมตรงกับความสนใจหรือคุณลักษณะเฉพาะตัว<br></br></text>
			<text>&emsp;อย่างไรก็ดี คุณสามารถควบคุมจัดการที่เกี่ยวกับโฆษณาและการวิเคราะห์ที่นำเสนอโดย Google ได้ที่ https://adssettings.google.com/ และ https://tools.google.com/dlpage/gaoptout   <br></br>  ซึ่งการจัดการ เปลี่ยนแปลงหรืออัปเกรดเบราว์เซอร์ของคุณหรือการลบคุกกี้ออกจากระบบดังกล่าว อาจต้องทำผ่านวิธีการเลือกไม่รับ (opt-out) อีกขั้นตอนหนึ่ง ซึ่งการต่อสัญญาณที่ไม่ได้ติดตามบนเบราว์เซอร์ดังกล่าวอยู่นอกเหนือความรับผิดชอบของบริษัทฯ<br></br></text>
			<text>&emsp;สำหรับการควบคุมจัดการความเป็นส่วนตัวเกี่ยวกับอุปกรณ์สื่อสารไร้สายของคุณ โปรดตรวจสอบรายละเอียดคำแนะนำเกี่ยวกับวิธีใช้การควบคุมความเป็นส่วนตัวเพิ่มเติมใดๆ ที่ระบบปฏิบัติการมือถือของคุณนำเสนอเช่นการตั้งค่าความเป็นส่วนตัวสำหรับตัวระบุอุปกรณ์และตำแหน่งทางภูมิศาสตร์ได้ด้วยตนเองที่เว็บไซต์ของผู้ผลิตอุปกรณ์อุปกรณ์สื่อสารไร้สายของคุณ <br></br></text>
			
		<h3>ลิงค์ของบุคคลที่สาม</h3>
			•	เว็บไซต์และแอปพลิเคชันของ C3Leng อาจมีลิงก์ของเว็บไซต์อื่นๆ (“บุคคลที่สาม”) ซึ่งไม่อยู่ภายใต้การดูแลของบริษัทฯ คุณควรตรวจสอบนโยบายความเป็นส่วนตัวของเว็บไซต์ของบุคคลที่สามอย่างละเอียดก่อน การนำเสนอลิงก์ของบุคคลที่สามนั้น มีไว้เพื่อความสะดวกที่ผู้ใช้บริการของบริษัทฯสามารถค้นหาข้อมูลเพิ่มเติมเกี่ยวกับหัวข้อบางอย่าง โดยบุคคลที่สามนั้นไม่ได้ให้หรือแชร์ข้อมูลใดๆ ของคุณกับบริษัทฯแต่อย่างใด ดังนั้นบริษัทฯไม่มีความรับผิดชอบต่อการปกป้องความเป็นส่วนตัวหรือเนื้อหาของเว็บไซต์ของบุคคลที่สาม ไม่ว่าบางส่วนหรือทั้งหมด
		 
		<h3>บริษัทฯใช้ข้อมูลที่รวบรวมอย่างไร</h3>
		<text>&emsp;บริษัทฯใช้หรือเปิดเผยข้อมูลของคุณเฉพาะด้วยความยินยอมโดยนัยหรือโดยชัดแจ้งที่ระบุไว้ในระเบียบข้อบังคับของกฎหมายที่บังคับทั้งหมดในเขตอำนาจศาลที่เกี่ยวข้องเท่านั้น ตามวัตถุประสงค์ดังต่อไปนี้<br></br></text>
		<text>	
			&ensp;•	เพื่อวัตถุประสงค์ทางธุรกิจของบริษัทฯ บริษัทฯจะใช้และเก็บข้อมูลเพื่อประมวลผล วิเคราะห์และปรับปรุงธุรกิจของบริษัทฯ ซึ่งรวมถึงจัดสรรบริการบนแพลตฟอร์ม C3Leng<br></br>
			&ensp;•	เพื่อการรักษาความปลอดภัยทางไซเบอร์ บริษัทฯใช้หรือวิเคราะห์ข้อมูลในการตรวจสอบพฤติกรรมหรือกิจกรรมที่อาจผิดกฎหมายเพื่อการป้องกันการฉ้อโกงหรืออาชญากรรมต่างๆ <br></br>
			&ensp;•	เพื่อส่งข้อมูลข่าวสารเกี่ยวกับธุรกิจบางอย่างของบริษัทฯให้แก่คุณ รวมถึงการประชาสัมพันธ์ การส่งเสริมการขาย การเปลี่ยนแปลงนโยบายต่างๆ ของแพลตฟอร์มและการสื่อสารทางการตลาด<br></br>
			&ensp;•	เพื่อการปรับแต่งเนื้อหาและการโฆษณาที่คุณพบเห็นบนเว็บไซต์และแอพของบริษัทฯผ่านทางอินเทอร์เน็ตและที่อื่นๆ<br></br>
			</text>

		<h3>การเปิดเผยข้อมูลที่บริษัทฯรวบรวม</h3>
		<text>	
			&ensp;•	บริษัทฯอาจแบ่งปันข้อมูลตามกฎหมายหรือคำขออย่างเป็นทางการของหน่วยงานของรัฐ<br></br>
			&ensp;•	บริษัทฯอาจแบ่งปันข้อมูลที่ไม่อาจระบุตัวตนของคุณกับบริษัทในเครือของบริษัทฯ ซึ่งถือเป็นส่วนหนึ่งในการดำเนินธุรกิจตามปกติของบริษัทฯ
			</text>
		<h3>ระยะเวลาการเก็บข้อมูล</h3>
			<text>&emsp;บริษัทฯจะเก็บรักษาข้อมูลต่างๆ ตราบเท่าที่จำเป็นในการดำเนินธุรกิจของบริษัทฯ หรือตามที่กำหนดไว้ตามกฎหมายของประเทศไทย ซึ่งโดยปกติเป็นระยะเวลา 2 ปีหลังจากนับตั้งแต่เมื่อมีการปิดหรือลบบัญชีสมาชิกหรือตามระยะเวลาที่กำหนดโดยกฎหมายที่เกี่ยวข้อง เมื่อครบกำหนดเวลาดังกล่าว บริษัทฯจะลบข้อมูลนั้นออกจากฐานข้อมูลของบริษัทฯ<br></br></text>
			<text>&emsp;อย่างไรก็ดี คุณอาจใช้สิทธิเพื่อปกป้องความเป็นส่วนตัวของคุณที่จะขอลบหรือทำลายข้อมูลของคุณจากฐานข้อมูลของบริษัทฯได้ โดยทำคำขอเป็นลายลักษณ์อักษรส่งถึงบริษัทฯที่อีเมล์ adminc3leng@c3leng.com</text>
		 
		<h3>การปรับปรุงและแก้ไขนโยบายนี้</h3>
			<text>&emsp;บริษัท แก้วกรุงไทย จำกัด ขอสงวนสิทธิ์ตามดุลยพินิจแต่เพียงผู้เดียวในการเปลี่ยนแปลง แก้ไขหรือลบบางส่วนของนโยบายนี้ได้ตลอดเวลา โปรดติดตามตรวจสอบการเปลี่ยนแปลงหรือแก้ไขเพิ่มเติมนโยบายความเป็นส่วนตัวนี้บนหน้าเว็บไซต์และแพลตฟอร์ม C3Leng <br></br></text>
			<text>&emsp;การที่คุณใช้งานหรือบริการบนเว็บไซต์ต่อไปหลังจากที่มีการเปลี่ยนแปลงหรือแก้ไขเพิ่มเติมนโยบายนี้ ถือว่าคุณได้แสดงเจตนาตกลงยอมรับเงื่อนไขไม่เฉพาะแต่เพียงบางส่วน แต่ทั้งหมด</text>
		<br></br>
		<br></br>
		<br></br>
		นโยบายนี้ปรับปรุงล่าสุดและมีผลใช้บังคับตั้งแต่วันที่ 9 เมษายน 2563<br></br>
		</text>
		</div>
        );
        //const user = this.onUserChange(this.state.currentPage);
        //console.log(user);
        //Step 1 : Content page 1.
        const pageOne = (
            
            <div className="p-grid">
                 {/* <div className="p-col-12">
                    <AddU3View
                        {...this.state}
                        onSelectAutoCompleteSearchName={this.onSelectAutoCompleteSearchName}
                        suggestBrands={this.suggestBrands}
                        onUsernameChanged={this.onUsernameU3Changed}
                        onAddU3={this.onAddU3}
                        itemTemplateAutoComplete={this.itemTemplateAutoComplete}
                        onChangeChips={this.onChangeChips}
                        itemTemplateChipU3 = {this.itemTemplateChipU3}
                        onRemove={this.onRemoveU3}
                            />
                </div> */}
                <div className="p-col-12">
                    <label className="register-label required">ชื่อเข้าใช้งาน (Username) </label>
                </div>

                <div className="p-col-12">
                    <span style={{ color: 'red' }}>{this.state.errorMessageUsername} </span><span style={{ color: 'green' }}>{this.state.messageUsername}</span>
                    {/* <InputText type="text" value={this.state.username} className="input-100" onChange={(e) => this.onUsernameChanged(e.target.value)} /> */}
                    <CEInputText  
                            id="username"                         
                            type="text"
                            className="input-100"
                            value={this.state.username}
                            name="username"
                            placeholder="ชื่อเข้าใช้งาน"
                            tooltip="กรอกชื่อเข้าใช้งานเป็นภาษาอังกฤษและตัวเลขเท่านั้น"
                            minlength={6}
                            maxlength={45}
                            required={true}
                            regexp="^[A-Za-z][A-Za-z0-9]*$"
                            onChange={(e)=> this.onUsernameChanged(e.target.value)}
                            isvalid={(valid) => console.log(valid)}
                             />
                </div>

                <div className="p-col-12">
                    <label className="register-label required">รหัสผ่าน (Password)</label>
                </div>
                <div className="p-col-12">
                    <span style={{ color: 'red' }}>{this.state.errorMessagePassword} </span>
                    {/* <InputText type={this.state.typePasswordInput} value={this.state.password} className="input-100" onChange={(e) => this.onPasswordChanged(e.target.value)} /> */}
                    
                    <CEPassword
                            regexp={"^(?=.*[a-z])(?=.*[A-Z]).{6,}$"}                           
                            type={this.state.typePasswordInput}
                            className="input-100"
                            value={this.state.password}
                            name="typePasswordInput"
                            placeholder="รหัสผ่าน"
                            tooltip={this.state.errorMessagePassword}
                            minlength={6}
                            maxlength={100}
                            required={true}
                            onChange={(e)=> this.onPasswordChanged(e.target.value)}
                            isvalid={(valid) => console.log(valid)}
                             />
                </div>

                <div className="p-col-12">
                    <label className="register-label ">รหัสผ่านอีกครั้ง (Re Password)</label>
                </div>
                <div className="p-col-12">
                    <span style={{ color: 'red' }}>{this.state.errorMessageConfirmPassword} </span>
                    {/* <InputText type={this.state.typePasswordInput} value={this.state.confirmPassword} className="input-100" onChange={(e) => this.onConfirmPasswordChanged(e.target.value)} /> */}
                    <CEPassword
                            regexp={"^(?=.*[a-z])(?=.*[A-Z]).{6,}$"}                           
                            type={this.state.typePasswordInput}
                            className="input-100"
                            value={this.state.confirmPassword}
                            name="typePasswordInput"
                            placeholder="กรอกรหัสผ่านอีกครั้ง"
                            tooltip={this.state.errorMessagePassword}
                            minlength={6}
                            maxlength={100}
                            required={true}
                            onChange={(e)=> this.onConfirmPasswordChanged(e.target.value)}
                            isvalid={(valid) => console.log(valid)}
                             />
                </div>

                <div className="p-col-12 p-md-4 p-lg-4" >
                    <ToggleButton style={{ width: '150px', backgroundColor: '#43a047', color: '#ffffff', borderColor: '#3b8e3f' }} onLabel="ซ่อนรหัสผ่าน" offLabel="แสดงรหัสผ่าน" onIcon="fa fa-eye-slash" offIcon="fa fa-eye"
                        checked={this.state.checkedPasswordVisible} onChange={(e) => this.setPasswordVisible(e)} />


                </div>

                <div className="p-col-12">
                    <label className="register-label required">คุณเป็นอย่างใดต่อไปนี้</label>
                </div>
                <div className="p-col-12 p-md-6 p-lg-6">
                    <RadioButton inputId="rb1" name="personType" value="1"
                        onChange={(e) => this.setState({ personType: e.value })}
                        checked={this.state.personType === '1'} />
                    <label htmlFor="rb1" className="p-radiobutton-label">บุคคลธรรมดา</label>
                </div>
                <div className="p-col-12 p-md-6 p-lg-6">
                    <RadioButton inputId="rb2" name="personType" value="2"
                        onChange={(e) => this.setState({ personType: e.value })}
                        checked={this.state.personType === '2'} />
                    <label htmlFor="rb2" className="p-radiobutton-label">นิติบุคคล</label>
                </div>
                <div className="p-col-12 p-md-6 p-lg-6" style={{ marginBottom: '.5em' }}>
                    {/* {user} */}
                </div>
                
            </div>
        );
        //Step 2 : Content page 2.
        const pageTwo = (
            <div className="p-grid">
                {/* page 2 */}
                <div className="p-col-12 p-md-12 p-lg-4" style={{ textAlign: 'left' }}>
                    <label class="register-label required">หมายเลขโทรศัพท์ 1</label>
                </div>
                <div className="p-col-12 p-md-12 p-lg-8" style={{ textAlign: 'left' }}>
                    <span style={{ color: 'red' }}>{this.state.errorMessageTelephoneNumber1} </span>
                    {/* <InputText type="text" keyfilter="pint" maxLength="10" className="input-100"
                        placeholder="หมายเลขโทรศัพท์มือถือ 1" value={this.state.telephoneNumber1} 
                        onChange={(e) => this.onTelephoneNumber1Changed(e.target.value)} /> */}
                    <CEInputText  
                            id="telephoneNumber1"                         
                            type="telephone"
                            className="input-100"
                            value={this.state.telephoneNumber1}
                            name="telephoneNumber1"
                            placeholder="หมายเลขโทรศัพท์"
                            tooltip="กรอกหมายเลขโทรศัพท์ 10 หลัก"
                            mask="9999999999"
                            required={true}
                            onChange={(e,v)=> this.onTelephoneNumber1Changed(e.target.value,v)}
                            isvalid={(valid) => this.setState({isvalid_telephoneNumber1:valid})}
                             />
                </div>
                <div className="p-col-12 p-md-12 p-lg-4" style={{ textAlign: 'left' }}>
                    <label className="register-label ">หมายเลขโทรศัพท์ 2</label>
                </div>
                <div className="p-col-12 p-md-12 p-lg-8" style={{ textAlign: 'left' }}>
                    {/* <InputText type="text" keyfilter="pint" maxLength="10" className="input-100" 
                        placeholder="หมายเลขโทรศัพท์ 2" value={this.state.telephoneNumber2} 
                        onChange={(e) => this.setState({ telephoneNumber2: e.target.value })} /> */}
                    <CEInputText
                            id="telephoneNumber2"                           
                            type="text"
                            className="input-100"
                            value={this.state.telephoneNumber2}
                            name="telephoneNumber2"
                            placeholder="หมายเลขโทรศัพท์มือถือ 2"
                            tooltip="กรอกหมายเลขโทรศัพท์ 10 หลัก"
                            maxlength={100}
                            required={false}
                            onChange={(e)=> this.setState({ telephoneNumber2: e.target.value })}
                            isvalid={(valid) => console.log(valid)}
                             />
                </div>
                <div className="p-col-12 p-md-12 p-lg-4" style={{ textAlign: 'left' }}>
                    <label className="register-label ">Line ID</label>
                </div>
                <div className="p-col-12 p-md-12 p-lg-8" style={{ textAlign: 'left' }}>
                    {/* <InputText type="text" className="input-100"
                        placeholder="Line ID" value={this.state.lineId} onChange={(e) => this.setState({ lineId: e.target.value })} /> */}
                    <CEInputText 
                            id="lineId"                          
                            type="text"
                            className="input-100"
                            value={this.state.lineId}
                            name="lineId"
                            placeholder="Line ID"
                            tooltip="กรอก Line Id "
                            maxlength={45}
                            required={false}
                            onChange={(e)=> this.setState({lineId: e.target.value})}
                            isvalid={(valid) => console.log(valid)}
                             />
                </div>
                <div className="p-col-12 p-md-12 p-lg-4" style={{ textAlign: 'left' }}>
                    <label className="register-label ">Email Address</label>
                </div>
                <div className="p-col-12 p-md-12 p-lg-8" style={{ textAlign: 'left' }}>
                    {/* <InputText type="text" className="input-100" keyfilter="email"
                        placeholder="Email Address" value={this.state.email} onChange={(e) => this.setState({ email: e.target.value })} /> */}
                    
                    <CEInputText  
                            id="email"                         
                            type="email"
                            className="input-100"
                            value={this.state.email}
                            name="email"
                            placeholder="Email Address"
                            tooltip="กรอก Email"
                            maxlength={45}
                            required={false}
                            onChange={(e)=> this.setState({email: e.target.value})}
                            isvalid={(valid) => this.setState({isvalid_email:valid})}
                             />
                </div>
                <div className="p-col-12" >
                    <label class="register-label required">ประเภทรถยานพาหนะ</label>
                </div>

                <div className="p-col-12 p-md-12 p-lg-6" style={{ textAlign: 'left' }}>
                    <RadioButton inputId="rb_vehical1"
                        name="มอเตอร์ไซต์" value="มอเตอร์ไซต์"
                        onChange={(e) => this.setState({ vehicleType: 1, vehicle: e.value }, this.isNotvalidStep2)}
                        checked={this.state.vehicle === 'มอเตอร์ไซต์'} />
                    <label htmlFor="rb_vehical1" className="p-radiobutton-label">มอเตอร์ไซต์</label>
                </div>
                <div className="p-col-12 p-md-12 p-lg-6" style={{ textAlign: 'left' }}>
                    <RadioButton inputId="rb_vehical2"
                        name="ซาเล้ง" value="ซาเล้ง"
                        onChange={(e) => this.setState({ vehicleType: 2, vehicle: e.value }, this.isNotvalidStep2)}
                        checked={this.state.vehicle === 'ซาเล้ง'} />
                    <label htmlFor="rb_vehical2" className="p-radiobutton-label">ซาเล้ง</label>
                </div>
                <div className="p-col-12 p-md-12 p-lg-6" style={{ textAlign: 'left' }}>
                    <RadioButton inputId="rb_vehical3"
                        name="รถกระบะและบรรทุก 4 ล้อ" value="รถกระบะและบรรทุก 4 ล้อ"
                        onChange={(e) => this.setState({ vehicleType: 3, vehicle: e.value }, this.isNotvalidStep2)}
                        checked={this.state.vehicle === 'รถกระบะและบรรทุก 4 ล้อ'} />
                    <label htmlFor="rb_vehical3" className="p-radiobutton-label">รถกระบะและบรรทุก 4 ล้อ</label>
                </div>
                <div className="p-col-12 p-md-12 p-lg-6" style={{ textAlign: 'left' }}>
                    <RadioButton inputId="rb_vehical4"
                        name="รถบรรทุก 6 ล้อ" value="รถบรรทุก 6 ล้อ"
                        onChange={(e) => this.setState({ vehicleType: 4, vehicle: e.value }, this.isNotvalidStep2)}
                        checked={this.state.vehicle === 'รถบรรทุก 6 ล้อ'} />
                    <label htmlFor="rb_vehical4" className="p-radiobutton-label">รถบรรทุก 6 ล้อ</label>
                </div>
                <div className="p-col-12 p-md-12 p-lg-6" style={{ textAlign: 'left' }}>
                    <RadioButton inputId="rb_vehical5"
                        name="รรถบรรทุก 10 ล้อ" value="รรถบรรทุก 10 ล้อ"
                        onChange={(e) => this.setState({ vehicleType: 5, vehicle: e.value }, this.isNotvalidStep2)}
                        checked={this.state.vehicle === 'รรถบรรทุก 10 ล้อ'} />
                    <label htmlFor="rb_vehical5" className="p-radiobutton-label">รถบรรทุก 10 ล้อ</label>
                </div>
                <div className="p-col-12 p-md-12 p-lg-6" style={{ textAlign: 'left' }}>
                    <RadioButton inputId="rb_vehical6"
                        name="รถพ่วง" value="รถพ่วง"
                        onChange={(e) => this.setState({ vehicleType: 6, vehicle: e.value }, this.isNotvalidStep2)}
                        checked={this.state.vehicle === 'รถพ่วง'} />
                    <label htmlFor="rb_vehical6" className="p-radiobutton-label">รถพ่วง</label>
                </div>
                <div className="p-col-12 p-md-12 p-lg-4" style={{ textAlign: 'left' }}>
                    <label className="register-label ">ทะเบียนรถ</label>
                </div>
                <div className="p-col-12 p-md-12 p-lg-8" style={{ textAlign: 'left' }}>
                    {/* <InputText type="text" value={this.state.vehicleNo} className="input-100" placeholder="ทะเบียนรถ" onChange={(e) => this.setState({ vehicleNo: e.target.value })} /> */}
                    <CEInputText
                            id="vehicleNo"                           
                            type="text"
                            className="input-100"
                            value={this.state.vehicleNo}
                            name="vehicleNo"
                            placeholder="ทะเบียนรถ"
                            tooltip="กรอกทะเบียนรถ"
                            maxlength={25}
                            required={false}
                            onChange={(e)=> this.setState({vehicleNo: e.target.value})}
                            isvalid={(valid) => console.log(valid)}
                             />
                </div>
                <div className="p-col-12">
                    <label className="register-label ">รูปถ่ายรถปัจจุบัน</label>
                </div>

                <div className="p-col-12" >
                    { this.state.fileImgVehicle == null &&
                         <FileUpload name="fileIDCard[]" 
                                onSelect={(e) => this.onFileVehicleChanged(e)}
                                mode="basic" 
                                chooseLabel="แนบไฟล์"
                                cancelLabel="ยกเลิก"
                                multiple={false} 
                                accept="image/*" 
                                maxFileSize={10000000}
                                value={this.state.fileImgVehicle} />
                    }
                    {
                        this.state.fileImgVehicle !=null &&
                        <Button type="button" style={{width: '150px', height:'50px'}} onClick={() => this.setState({fileImgVehicle:null})} icon="fa fa-trash" className="p-button-warning"  label="ลบไฟล์" ></Button>
                    }

                    
                </div>
            </div>


        );
        //Step 3 : Content page 3.
        const pageThree = (
            <div className="p-grid">
                {/* page 3 */}

                <div className="p-col-12" >
                    <h2>ต้องการเก็บขยะรีไซเคิลในพื้นที่ใด</h2>
                </div>


                <div className="p-col">
                    <div className="p-col-12" style={{ textAlign: 'left' }}>
                        <label class="register-label required">จังหวัด</label>
                    </div>

                    <div className="p-col-12" style={{ textAlign: 'left' }}>
                        {/* <Dropdown
                            style={{ width: "100%" }}
                            value={this.state.provinceSelected}
                            // options={this.state.provinceSelectItems} 
                            options={province}
                            onChange={this.onProvinceChanged} optionLabel="province_name" placeholder="เลือกจังหวัด" /> */}
                        <CEDropdown
                                required={true} 
                                style={{ width: "100%" }}
                                value={this.state.provinceSelected}
                                options={province}
                                onChange={this.onProvinceChanged} 
                                optionLabel="province_name" 
                                placeholder="เลือกจังหวัด" 
                                isvalid={(valid) => console.log(valid)}/>
                    </div>
                </div>
                <div className="p-col">
                    <div className="p-col-12" style={{ textAlign: 'left' }}>
                        <label class="register-label required">อำเภอ/เขต</label>
                    </div>
                    <div className="p-col-12" style={{ textAlign: 'left' }}>
                        {/* <Dropdown
                            style={{ width: "100%" }}
                            value={this.state.districtSelected}
                            options={district}
                            onChange={this.onDistrictChanged} optionLabel="districtName" placeholder="อำเภอ/เขต" /> */}
                        <CEDropdown
                            required={true} 
                            style={{ width: "100%" }}
                            value={this.state.districtSelected}
                            options={district}
                            onChange={this.onDistrictChanged} optionLabel="districtName" placeholder="อำเภอ/เขต"
                            isvalid={(valid) => console.log(valid)} />
                    </div>
                </div>
                
               
                <div className="p-col-12" >
                    <Chips
                        style={{ margin: '7px',width:'100%' }}
                        value={this.state.districtsSelected}
                        itemTemplate={this.customChip}
                        onRemove={this.customChipRemove}
                    >
                    </Chips>
                </div>  
                

                <div className="p-col-12">
                <div className="p-col-12" style={{ textAlign: 'left' }}>
                        <label class="register-label">ชื่อศูนย์จัดการฯซีซาเล้งที่ต้องการไปส่ง</label>
                    </div>
                <div className="p-col-12">
                    <AddU3View
                        {...this.state}
                        onSelectAutoCompleteSearchName={this.onSelectAutoCompleteSearchName}
                        suggestBrands={this.suggestBrands}
                        onUsernameChanged={this.onUsernameU3Changed}
                        onAddU3={this.onAddU3}
                        itemTemplateAutoComplete={this.itemTemplateAutoComplete}
                        onChangeChips={this.onChangeChips}
                        itemTemplateChipU3 = {this.itemTemplateChipU3}
                        onRemove={this.onRemoveU3}
                            />
                </div>
                </div>


                <div className="p-col-12 p-md-12 p-lg-6">
                    <div className="p-col-12">
                        <label className="register-label ">รูปถ่ายบัตรประชาชน / หนังสือรับรอง</label>

                    </div>
                    <div className="p-col-12">
                     

                    { this.state.fileImgIden == null &&
                         <FileUpload name="fileIDCard[]" 
                                onSelect={(e) => this.onFileIDCardChanged(e)}
                                mode="basic" 
                                chooseLabel="แนบไฟล์"
                                cancelLabel="ยกเลิก"
                                multiple={false} 
                                accept="image/*" 
                                maxFileSize={10000000}
                                value={this.state.fileImgIden} />
                    }
                    {
                        this.state.fileImgIden !=null &&
                        <Button type="button" style={{width: '150px', height:'50px'}} onClick={() => this.setState({fileImgIden:null})} icon="fa fa-trash" className="p-button-warning"  label="ลบไฟล์" ></Button>
                    }
                    </div>

                </div>
                <div className="p-col-12 p-md-12 p-lg-6">
                    <div className="p-col-12">
                        <label className="register-label ">กรณีเป็นนิติบุคคลรูปถ่าย ภพ20</label>
                    </div>
                    <div className="p-col-12">
                       
                    { this.state.fileImgRegis == null &&
                         <FileUpload name="fileImgRegis[]" 
                                onSelect={(e) => this.onFileRegisChanged(e)}
                                mode="basic" 
                                chooseLabel="แนบไฟล์"
                                cancelLabel="ยกเลิก"
                                multiple={false} 
                                accept="image/*" 
                                maxFileSize={10000000}
                                value={this.state.fileImgRegis} />
                    }
                    {
                        this.state.fileImgRegis !=null &&
                        <Button type="button" style={{width: '150px', height:'50px'}} onClick={() => this.setState({fileImgRegis:null})} icon="fa fa-trash" className="p-button-warning"  label="ลบไฟล์" ></Button>
                    }
                    </div>
                </div>
                <div className="p-col-12 p-md-12 p-lg-6">


                    <div className="p-col-12">

                        <label className="register-label ">รูปถ่ายสมาชิก</label>
                    </div>
                    <div className="p-col-12">
                        

                        { this.state.fileImgPerson == null &&
                         <FileUpload name="fileImgPerson[]" 
                                onSelect={(e) => this.onFilePersonChanged(e)}
                                mode="basic" 
                                chooseLabel="แนบไฟล์"
                                cancelLabel="ยกเลิก"
                                multiple={false} 
                                accept="image/*" 
                                maxFileSize={10000000}
                                value={this.state.fileImgPerson} />
                    }
                    {
                        this.state.fileImgPerson !=null &&
                        <Button type="button" style={{width: '150px', height:'50px'}} onClick={() => this.setState({fileImgPerson:null})} icon="fa fa-trash" className="p-button-warning"  label="ลบไฟล์" ></Button>
                    }
                    </div>
                </div>

                <div className="p-col-12 p-md-12 p-lg-5">

                </div>
            </div>

        );

        const pageFour = (
            <div className="p-grid" style={{ textAlign: 'center' }}>



                <div className="p-col-12  " >
                    <img alt="project" src='../assets/layout/images/register/correctimages.png' style={{ width: 150, height: 150 }} />
                </div>


                <div className="p-col-12 ">
                    <h1 >สมัครสมาชิกสำเร็จ</h1>
                </div>
                <div className="p-col-6 " style={{ textAlign: 'right' }}>
                    <a href="#/login"><Button  label="เข้าสู่ระบบ" /></a>
                </div>
                <div className="p-col-6" style={{ textAlign:'left' }}>
                    <a href="#/"><Button label="กลับสู่หน้าหลัก" /></a>
                </div>


            </div>

        );

        // === Logic select page ===
        switch (currentPage) {
            case 1:
                return (pageAgreement);
            case 2:
                return (pageOne);
            case 3:
                return (pageTwo);
            case 4:
                return (pageThree);
            case 5:
                return (pageFour);
            default:
                return (this.props.history.push('/#/'));
        }



    };


    nextPage = (e) => {
        console.log(this.state.currentPage);
        if (this.state.currentPage == 1) {
            this.inputRequestStep()
        } else if (this.state.currentPage == 2) {
            this.inputRequestStep1()
        } else if (this.state.currentPage == 3) {
            this.inputRequestStep2()
        }else if (this.state.currentPage == 4) {
            this.inputRequestStep3()
        }
    }
    backPage = (e) => {
        console.log(this.state.currentPage)
        if (this.state.currentPage == 2) {
            this.state.currentPage--;
            window.scrollTo(0,0)
            this.setState({ errorMessageLastStep: "" });
            this.forceUpdate();
        } else if (this.state.currentPage == 3) {
            this.state.currentPage--;
            window.scrollTo(0,0)
            this.setState({ errorMessageLastStep: "" });
            this.forceUpdate();
        } else if (this.state.currentPage == 4) {
            this.state.currentPage--;
            window.scrollTo(0,0)
            this.setState({ errorMessageLastStep: "" });
            this.forceUpdate();
        }
        
    }


 

    inputRequestStep() {
            console.log(this.state.currentPage);
            this.state.currentPage++;
            window.scrollTo(0,0)
            //e.preventDefault();
            this.forceUpdate();
            console.log(this.state.currentPage);
    };

   isNotvalidStep1() {
        this.setState({ errorMessageLastStep: "" });
        var inputSec1 = !(this.state.username == '' || this.state.password == '' || this.state.confirmPassword == '');
        var inputSec2 = !(this.state.prefixCode == 0 || this.state.firstName == '' || this.state.lastName == '');
        var inputSec3 = !(this.state.companyTypeCode == 0 || this.state.companyName == '' || this.state.companyNo == '' || !this.state.isvalid_companyNo);
        var inputAll = (inputSec1 && this.state.personType == 1 && inputSec2) || (inputSec1 && this.state.personType == 2 && inputSec3);
        var hasErrorMsg = (this.state.errorMessageUsername != '' || this.state.errorMessagePassword != '' || this.state.errorMessageConfirmPassword != '' || this.state.errorMessageOrgNo !='');
        if (!inputAll || hasErrorMsg) {
            this.setState({ errorMessageLastStep: "กรุณากรอกข้อมูลที่มีเครื่องหมาย * ให้ครบถ้วน" });
        } else
            this.setState({ errorMessageLastStep: "" });

        return !inputAll || hasErrorMsg;
    }
    inputRequestStep1() {

        if (!this.isNotvalidStep1()) {
            this.state.currentPage++;
            window.scrollTo(0,0)
            //e.preventDefault();
            //this.forceUpdate();
        }
    };

    isNotvalidStep2() {
        this.setState({ errorMessageLastStep: "" });
        var inputStep2 = !((this.state.telephoneNumber1 == '') || this.state.vehicleType == 0 || !this.state.isvalid_telephoneNumber1 || (!this.state.isvalid_email && this.state.email!="" ));
        var hasErrorMsg = this.state.errorMessageTelephoneNumber1 != '';
        if (!inputStep2 || hasErrorMsg) {
            this.setState({ errorMessageLastStep: "กรุณากรอกข้อมูลที่มีเครื่องหมาย * ให้ครบถ้วน" });
        } else
            this.setState({ errorMessageLastStep: "" });

        return !inputStep2 || hasErrorMsg;
    }
    inputRequestStep2() {
        if (!this.isNotvalidStep2()) {
            this.state.currentPage++;
            window.scrollTo(0,0)
            //e.preventDefault();
            //this.forceUpdate();
        }
    }

    isNotvalidStep3() {
        this.setState({ errorMessageLastStep: "" });
        var inputSec111 = this.state.districtsSelected.length > 0;
        console.log(this.state.districtsSelected)
        if (!inputSec111) {
            this.setState({ errorMessageLastStep: "กรุณากรอกข้อมูลที่มีเครื่องหมาย * ให้ครบถ้วน" });
        } else
            this.setState({ errorMessageLastStep: "" });
        return !inputSec111;
    }
    
    inputRequestStep3() {
        if (!this.isNotvalidStep3()) {
            this.setState({ showProgress: true });
            this.setState({ hideCancel: true });
            this.registerRequest();
            this.forceUpdate();
        }
    };




    btnBack(currentPage) {
        const back = (
            <Button className="p-button-warning" label="ยกเลิก" onClick={this.onCancelClick} />

        );
        const notAccept = (
            <Button className="p-button-warning" label="ไม่ยอมรับ" onClick={this.onCancelNotAccept} />

        );

        const hide = (
            <div>

            </div>
        )



        switch (currentPage) {
            case 1:
                return (notAccept);
            case 2:
                return (back);
            case 3:
                {
                    if (this.state.hideCancel) {
                        return (hide)
                    } else
                        return (back)
                }
            // case 4:
            //     return (pageFour);
        }
    }

    btnNext(currentPage) {
        const nextFirst = (
            <Button
                style={{ float: "right" }}
                type="submit"
                label="ยอมรับ"
                icon="pi pi-angle-double-right"
                iconPos="right"
                onClick={(this.nextPage.bind(this))}
            />

        );
        const next = (
            <Button
                style={{ float: "right" }}
                type="submit"
                label="ถัดไป"
                icon="pi pi-angle-double-right"
                iconPos="right"
                onClick={(this.nextPage.bind(this))}
            />

        );
        const nextSubmit = (
            <Button
                style={{ float: "right" }}
                type="submit"
                label="ยืนยัน"
                icon="pi pi-angle-double-right"
                iconPos="right"
                onClick={(this.nextPage.bind(this))}
            />
        );
        const Progress = (
            <div className="content-section implementation">
                <ProgressSpinner
                    style={{ width: '50px', height: '50px' }}
                    strokeWidth="8" fill="#EEEEEE"
                    animationDuration=".5s" />
            </div>
        );


        switch (currentPage) {
            case 1:
                return (nextFirst);
            case 2:
                return (next);
            case 3:
                return (next);
            case 4:
                {
                    if (this.state.showProgress) {
                        return (Progress);
                    } else
                        return (nextSubmit);
                }
            // case 4:
            //     return (pageFour);
        }

    }
    btnBackPage(currentPage) {

        const backPage = (
            <Button
                style={{ float: "right" }}
                type="submit"
                label="ย้อนกลับ"
                icon="pi pi-angle-double-left"
                iconPos="left"
                onClick={this.backPage.bind(this)}
            />);

        const hide = (
            <div>

            </div>
        )

        switch (currentPage) {
            // case 1:
            //     return (backPage);
            // case 2:
            //     return (backPage);
            case 3:
                return (backPage);
            case 4:
                {
                    if (this.state.hideCancel) {
                        return (hide)
                    } else
                        return (backPage)
                }
            // case 4:
            //     return (pageFour);
        }
    };




    render() {
        const {
            province,
        } = this.props

        //landing-wrapper
        let landingWrapper = classNames('landing-wrapper');
        let headerTop = classNames('header-top');
        let headerContent = classNames('header-content');
        let landingMenu = classNames('landing-menu');


        // === Render Body Content ===
        const bodyContent = this.showPage(this.state.currentPage);

        const user = this.onUserChange(this.state.currentPage);
        const back = this.btnBack(this.state.currentPage);
        const backpage = this.btnBackPage(this.state.currentPage);
        const next = this.btnNext(this.state.currentPage);




        return (
            <div className="register-body-tran">
                <Growl ref={(el) => this.growl = el} />
                <ScrollAnimation animateIn='bounceInRight'>

                    <div className="p-grid">

                        <div className="p-col-12 pg-md-12 p-lg-6"></div>
                        <div className="p-col-12 pg-md-12 p-lg-6">
                            <div className="register-panel">
                                <div class="register-panel-content">
                                    <Card>
                                        <div className="p-grid">
                                            <div className="p-col-12 p-md-6 p-lg-2 register-panel-content-header-icon"  >
                                                <img alt="project" src='../assets/layout/images/register/icon-login.svg' />
                                            </div>
                                            <div className="p-col-12  p-md-6 p-lg-10 register-panel-content-header">

                                                <h3>ยินดีต้อนรับสู่การลงทะเบียนทีมขนส่งซีซาเล้ง</h3>
                                                <h4 className="register-panel-content-sub-header">ลงทะเบียนเข้าสู่การใช้งาน C3 Leng</h4>
                                            </div>
                                        </div>

                                        {bodyContent}
                                        {user}

                                        <div className="p-grid">



                                            <div className="p-col-12" style={{ textAlign: 'center' }}>
                                                <span style={{ color: 'red' }}> {this.state.errorMessageLastStep}</span>
                                            </div>
                                            <div className="p-col-2" style={{ textAlign: 'left' }}>
                                                {back}
                                            </div>

                                            <div className="p-col-10" style={{ textAlign: 'right' }}>
                                                {next}
                                                {backpage}
                                            </div>


                                        </div>
                                    </Card>
                                </div>
                            </div>
                        </div>

                    </div>

                </ScrollAnimation>

            </div>

        );
    }
}



const mapStateToProps = (state) => ({
    province: state.location.province,
    district: state.location.district,
    subDistrict: state.location.subDistrict
})

const mapDispatchToProps = dispatch => ({

    locationServiceProps: bindActionCreators(LocationService, dispatch)

})


export default
    connect(
        mapStateToProps,
        mapDispatchToProps, null, { forwardRef: true })(WastetranRegisContainer)

